import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  connect() {
    this.element.addEventListener("click", this.copy.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("click", this.copy.bind(this))
  }

  get clipboardText() {
    if (this.hasTextValue) {
      return this.textValue
    } else if (this.element.dataset.clipboardText) {
      return this.element.dataset.clipboardText
    } else if (this.element.dataset.clipboardTarget) {
      const targetElement = document.querySelector(this.element.dataset.clipboardTarget)
      if (targetElement) {
        return targetElement.value || targetElement.textContent
      }
    }
    return undefined
  }

  async copy(event) {
    event.preventDefault()

    try {
      await navigator.clipboard.writeText(this.clipboardText)
      this.showTooltip("Copied!")
    } catch (err) {
      this.showTooltip(this.fallbackMessage())
    }
  }

  showTooltip(content) {
    const template = `<div class="tooltip right show" style="top: -2px; left: ${this.element.clientWidth + 2}px;">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">${content}</div>
                      </div>`

    this.element.style.position = "relative"
    this.element.insertAdjacentHTML("afterbegin", template)

    setTimeout(() => {
      const tooltip = this.element.querySelector(".tooltip")
      if (tooltip) tooltip.remove()
    }, 1500)
  }

  fallbackMessage() {
    if (/iPhone|iPad/i.test(navigator.userAgent)) {
      return "Not supported :("
    } else if (/Mac/i.test(navigator.userAgent)) {
      return "Press ⌘-C to copy"
    } else {
      return "Press Ctrl-C to copy"
    }
  }
}
